const state = {
  searchString: ''
}

const getters = {
  getSearchString: state => state.searchString
}

const mutations = {
  resetSearchBox (state) {
    state.searchString = ''
  },

  setSearchString (state, searchString) {
    state.searchString = searchString
  }
}

export default { state, getters, mutations }



// WEBPACK FOOTER //
// ./src/store/modules/common/searchBox.js